import { useCustomerStore } from '@stores/me/customer'
import { useKidStore } from '@stores/kid'

import { show404 } from '@utils/pages/error'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware( async (to) => {
  const signature = (to.query?.signature as string | undefined) ?? undefined
  if (signature) return

  const kidIdStr = to.params?.kid as string || undefined

  if (!kidIdStr) return

  const kidId = Number(kidIdStr)
  const validKidId = isFinite(kidId)

  if (!validKidId) return show404()

  const customerStore = useCustomerStore()
  const kidStore = useKidStore()

  await kidStore.setActiveKid(kidId)
  await kidStore.hydrateFromStorage()

  const allowedIds = new Set((customerStore.customer?.kids || []).map(kid => kid.id))

  if (!allowedIds.has(kidId)) {
    return show404()
  }
})
